import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';

export class NamingComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.namingComponent;
    }
    name:string;
}